module.exports = __webpack_public_path__ + "javaPostit.svg?28ffd63f990a32984124f04e74edd2ba";